export default "__VITE_ASSET__1rUHsGps__"